import React from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import Carding from "./Carding";
import Typography from "@mui/material/Typography";
import { auto } from "@popperjs/core";
import { Grid } from "@mui/material";
const CardContainer = (props) => {
  if (props.data.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,

            height: 128,
          },
        }}
      >
        <Typography variant="h4" gutterBottom>
          سفارشی یافت نشد!
        </Typography>
      </Box>
    );
  }
  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            height: "auto",
          },
        }}
        fullWidth
      >
        <Grid container spacing={2} sx={{ justifyContent: "center" }}>
          {props.data.map((order) => {
            return (
              <Carding
                key={order.id}
                orderId={order.id}
                patientName={order.patientName}
                doctorName={order.doctorName}
                orderType={order.orderType}
                boxNumber={order.boxNumber}
                unitCount={order.unitCount}
              />
            );
          })}
        </Grid>
      </Box>
    </React.Fragment>
  );
};

export default CardContainer;
